module.exports = __webpack_public_path__ + "images/emoji/information_source.b8be59132a1fd4835b12.png";